import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MUISelect from '@mui/material/Select';
import { styled } from '../styles';
import Typography from '../Typography';
const Container = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px'
}));
const Select = styled(MUISelect)(() => ({
  background: '#F5F7F9',
  '& .MuiSelect-select': {
    padding: '12px'
  }
}));
export function ListPerPageSelect(_ref) {
  let {
    id,
    disabled,
    perPageValue,
    perPageOptions,
    onChange,
    labelPerPage
  } = _ref;
  const labelId = id || 'listPerPageSelectLabel';
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(InputLabel, {
    id: labelId,
    sx: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "overline"
  }, labelPerPage)), /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(Select, {
    labelId: labelId,
    value: perPageValue,
    onChange: onChange,
    displayEmpty: true,
    inputProps: {
      'aria-label': labelPerPage
    },
    disabled: disabled
  }, perPageOptions.map(opt => /*#__PURE__*/React.createElement(MenuItem, {
    key: opt.value,
    value: opt.value
  }, /*#__PURE__*/React.createElement(Typography, null, opt.label || opt.value))))));
}
export default ListPerPageSelect;